import { render, staticRenderFns } from "./HealtReportView.vue?vue&type=template&id=4c78bdee&"
import script from "./HealtReportView.vue?vue&type=script&lang=js&"
export * from "./HealtReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports